/**
 * Format a YYYY-MM-DD date string as M/D/YYYY (US month-day-year).
 * Splits the string directly to avoid UTC/timezone shift from `new Date()`.
 */
export function formatTxnDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const [y, m, d] = parts;
  return `${parseInt(m)}/${parseInt(d)}/${y}`;
}

/**
 * Format a YYYY-MM-DD date string as zero-padded MM/DD/YYYY so dates align
 * in tabular columns (01/05/2024 over 12/25/2024). Longer ISO strings are
 * truncated to the date part. String-split parsing — never `new Date(iso)`,
 * which shifts a day on non-UTC machines.
 */
export function fmtDateNumeric(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  const parts = dateStr.slice(0, 10).split('-');
  if (parts.length !== 3) return dateStr;
  const [y, m, d] = parts;
  if (!y || !m || !d) return dateStr;
  return `${m.padStart(2, '0')}/${d.padStart(2, '0')}/${y}`;
}
